(function () {
  var SECTION_SELECTOR = '[data-oc-mr-newest-hosts]';
  var DESKTOP_MQ = '(min-width: 769px)';

  function toInt(value, fallback) {
    var parsed = parseInt(value, 10);
    return Number.isNaN(parsed) ? fallback : parsed;
  }

  function isDesktop() {
    return window.matchMedia(DESKTOP_MQ).matches;
  }

  function destroySwiper(sectionElement) {
    if (sectionElement._ocMrNewestHostsSwiper) {
      sectionElement._ocMrNewestHostsSwiper.destroy(true, true);
      delete sectionElement._ocMrNewestHostsSwiper;
    }
    delete sectionElement.dataset.ocMrNewestHostsInit;
  }

  function initSwiper(sectionElement) {
    // PC 为静态纵列列表，不启用 Swiper
    if (isDesktop()) {
      destroySwiper(sectionElement);
      sectionElement.dataset.ocMrNewestHostsInit = 'desktop';
      return true;
    }

    if (sectionElement.dataset.ocMrNewestHostsInit === 'true') {
      return true;
    }

    var swiperElement = sectionElement.querySelector('[data-newest-swiper]');
    if (!swiperElement || typeof Swiper === 'undefined') {
      return false;
    }

    var slideCount = toInt(sectionElement.dataset.slideCount, 0);
    var paginationEl = sectionElement.querySelector('[data-newest-pagination]');

    destroySwiper(sectionElement);

    var swiper = new Swiper(swiperElement, {
      slidesPerView: 'auto',
      slidesPerGroup: 1,
      spaceBetween: 10,
      loop: false,
      speed: 450,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      allowTouchMove: slideCount > 1,
      pagination:
        paginationEl && slideCount > 1
          ? {
              el: paginationEl,
              clickable: true,
            }
          : undefined,
    });

    sectionElement._ocMrNewestHostsSwiper = swiper;
    sectionElement.dataset.ocMrNewestHostsInit = 'true';
    return true;
  }

  function initSection(sectionElement) {
    if (!initSwiper(sectionElement)) {
      window.setTimeout(function () {
        initSwiper(sectionElement);
      }, 300);
    }
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  function onResize() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(function (sectionElement) {
      var mode = isDesktop() ? 'desktop' : 'mobile';
      var current = sectionElement.dataset.ocMrNewestHostsInit;
      if (mode === 'desktop' && current === 'true') {
        destroySwiper(sectionElement);
        sectionElement.dataset.ocMrNewestHostsInit = 'desktop';
      } else if (mode === 'mobile' && current !== 'true') {
        initSection(sectionElement);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  window.addEventListener('resize', onResize);

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var sectionElement = event.target.querySelector(SECTION_SELECTOR);
    if (sectionElement) destroySwiper(sectionElement);
  });
})();
